import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from './common';
import { IMenuOption } from './models';
import { AuthenticationService } from './services/authentication.service';
import { BlockUiHandlerService } from './services/block-ui-handler.service';
import { SideBarService } from './services/side-bar.service';
import { StorageService } from './services/storage.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faHome, faFile, faSlidersH, faSignOutAlt, faUsers } from '@fortawesome/free-solid-svg-icons';
import { IPermission } from './models/i-permission';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  opened: boolean = true;

  sidebarMode = 'push';

  menu: IMenuOption[];

  @Input() currentUser: any;

  permissions: IPermission[] = [];

  constructor(
    private router: Router,
    private sidebarService: SideBarService,
    private blockUI: BlockUiHandlerService,
    private authtenticationService: AuthenticationService,
    private storageService: StorageService,
    library: FaIconLibrary
  ) {
    library.addIcons(faHome, faFile, faSlidersH, faSignOutAlt, faUsers)
    this.menu = Constants.GetMenu;
    this.sidebarService.toggler.subscribe((toggle) => (this.opened = toggle));
    this.ValidateSession();
    this.authtenticationService.currentUser.subscribe(x => this.currentUser = x);
    
  }
  ngOnInit(): void {
    this.permissions = this.storageService.GetPermissions();
    this.opened = this.currentUser !== null;
  }

  openedChange($event) { }

  onClickMenuOption(menuOption: IMenuOption) {
    this.menu.forEach(x => {
      if(menuOption.Name != x.Name ) x.Selected = false;
      if (x.Children.length > 0) {
        x.Children.forEach(y => y.Selected = false);
      }
    });

    if (menuOption.Name === 'Salir') {
      this.opened = false;
      this.sidebarService.currentPath.next('Inicio');
      this.authtenticationService.logout();
    }
    else {
      menuOption.Selected = !menuOption.Selected;
      if (menuOption.Children.length === 0) {
        this.sidebarService.currentPath.next(menuOption.Name);
        this.router.navigateByUrl(menuOption.Route);
      }
    }
  }

  ValidateSession(): void {
    if (this.authtenticationService.anyActiveSession())
      this.authtenticationService.loadSessionFromLocalStorage();
  }

  TriggerPath(_path: string) {
    this.router.navigate(['/', _path]);
  }

  ValidatePermission(option: IMenuOption){
    return !!this.permissions.filter(permission => permission.Code === option.RequiredPerm).length;
  }
  // *ngIf="option.RequiredPerm === '' || ValidatePermission(option)"
}
